import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import {
  FaPlus,
  FaFilter,
  FaRedo,
  FaTrashAlt,
  FaEdit,
  FaEye,
  FaLink,
} from "react-icons/fa";

const LibraryBookOrderTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([
    {
      name: "Book One",
      category: "Fiction",
      author: "Author A",
      publication: "Publisher A",
      ordered: "2024-12-15",
      status: "Pending",
    },
    {
      name: "Book Two",
      category: "Science",
      author: "Author B",
      publication: "Publisher B",
      ordered: "2024-12-16",
      status: "Completed",
    },
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div >
      <h4>Library Book Orders</h4>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Button variant="primary" className="d-flex align-items-center mb-3 mt-3">
          <FaPlus className="me-2 " />  Add Order
        </Button>
        <div className="d-flex align-items-center">
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaFilter
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaFilter />
          </Button>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
        </div>
      </div>
      <Card>
        <Card.Body>
          <div>
            <Table
              striped
              bordered
              hover
              style={{ overflow: "auto" }}
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Author</th>
                  <th>Publication</th>
                  <th>Ordered</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.category}</td>
                    <td>{item.author}</td>
                    <td>{item.publication}</td>
                    <td>{item.ordered}</td>
                    <td>
                      <span
                        className={`badge ${
                          item.status === "Completed"
                            ? "bg-success"
                            : item.status === "Pending"
                            ? "bg-warning"
                            : "bg-danger"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td className="text-center">
                      <Dropdown
                        className={`dropdown ${
                          filteredData.length === 1 ? "dropend" : ""
                        }`}
                      >
                        <Dropdown.Toggle
                          variant="light"
                          size="sm"
                          className="border-0"
                        >
                          Actions
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                          <Dropdown.Item>
                            <FaEye className="me-2 text-info" /> View
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <FaEdit className="me-2 text-primary" /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <FaLink className="me-2 text-secondary" /> Reference
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(index)}>
                            <FaTrashAlt className="me-2 text-danger" /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
                {!filteredData.length && (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No results found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span>
              Showing {filteredData.length} of {data.length} entries
            </span>
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item active>1</Pagination.Item>
              <Pagination.Item>2</Pagination.Item>
              <Pagination.Next />
            </Pagination>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default LibraryBookOrderTable;
